import * as React from "react";
import { useEffect } from "react";
interface DocumentUploaderProps {
    handleOnDropFiles: (files: any, callback?: any) => void
}
const DocumentUploader: React.FC<DocumentUploaderProps> = props => {
    const inputFileRef: any = React.createRef();
    const fileLabelRef: any = React.createRef();

    useEffect(() => {
        fileLabelRef.current.focus();
    }, []);

    const dragOver = e => {
        e.stopPropagation();
        e.preventDefault();
        e.dataTransfer.dropEffect = "copy";
    };

    const dragEnter = e => {
        e.preventDefault();
    };

    const dragLeave = e => {
        e.preventDefault();
    };

    const fileDrop = e => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        props.handleOnDropFiles(files, () => (inputFileRef.current.value = ""));
    };
    const onClickDropzone = () => {
        inputFileRef.current.click();
    };

    return (
        <>
            <div className="row">
                <label
                    ref={fileLabelRef}
                    className="dz-container"
                    htmlFor="uploadFile"
                    onDragOver={dragOver}
                    onDragEnter={dragEnter}
                    onDragLeave={dragLeave}
                    onDrop={fileDrop}
                >
                    <section className="dropzone">
                        <div>
                            <p className="upload-icon">
                                <i className="fas fa-file-upload" aria-hidden="true"></i>
                            </p>
                            <p className="dropzone-msg">Click or drag files here</p>
                        </div>
                    </section>
                    <input
                        ref={inputFileRef}
                        type="file"
                        id="uploadFile"
                        onChange={e => props.handleOnDropFiles(e.target.files, () => (inputFileRef.current.value = ""))}
                        multiple
                    />
                </label>
            </div>
        </>
    );
};

export default DocumentUploader;
